<template>
  <b-container>
    <b-row>
      <b-col
        sm="12"
        md="12"
        lg="8"
        xl="6"
      >
        <b-card>
          <validation-observer ref="formValidation">
            <b-form @submit.prevent="validateForm()">
              <b-row>
                <b-col>
                  <h1 class="font-weight-bolder">
                    Alta de Producto
                  </h1>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="12">
                  <b-form-group :label="$t('productName')">
                    <validation-provider
                      #default="{ errors }"
                      name="Nombre"
                      rules="required"
                    >
                      <b-form-input
                        v-model="product_catalog.name"
                        size="lg"
                        class="font-weight-bolder"
                        autocomplete="off"
                        type="text"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col
                  sm="12"
                  lg="6"
                >
                  <b-form-group :label="$t('SKU')">
                    <validation-provider
                      #default="{ errors }"
                      name="SKU"
                      rules="required"
                    >
                      <b-form-input
                        v-model="product_catalog.sku"
                        size="lg"
                        class="font-weight-bolder"
                        autocomplete="off"
                        type="text"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col
                  sm="12"
                  lg="6"
                >
                  <b-form-group :label="$t('category')">
                    <validation-provider
                      #default="{ errors }"
                      name="Categoría"
                      rules="required"
                    >
                      <b-form-select
                        v-model="product_catalog.category_id"
                        :options="categories"
                        text-field="name"
                        value-field="id"
                        size="lg"
                        class="font-weight-bolder"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col
                  sm="12"
                  lg="6"
                >
                  <b-form-group :label="$t('brand')">
                    <validation-provider
                      #default="{ errors }"
                      name="Marca"
                    >
                      <b-form-input
                        v-model="product_catalog.brand"
                        size="lg"
                        class="font-weight-bolder"
                        autocomplete="off"
                        type="text"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col
                  sm="12"
                  lg="6"
                >
                  <b-form-group :label="$t('units')">
                    <validation-provider
                      #default="{ errors }"
                      name="unidades"
                      rules="required"
                    >
                      <b-form-select
                        v-model="product_catalog.unit_type"
                        :options="unitTypeOptions"
                        size="lg"
                        class="font-weight-bolder"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col sm="12">
                  <b-form-group :label="$t('tags')">
                    <v-select
                      v-model="product_catalog.product_tag_ids"
                      multiple
                      label="name"
                      :options="productTags"
                      :reduce="tag => tag.id"
                      :placeholder="$t('selectTags')"
                      :close-on-select="false"
                    />
                  </b-form-group>
                </b-col>
                <b-col sm="12">
                  <b-form-group :label="$t('description')">
                    <b-form-textarea
                      v-model="product_catalog.description"
                      no-resize
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  sm="12"
                  lg="4"
                >
                  <b-form-group label="Clave SAT del producto">
                    <validation-provider
                      #default="{ errors }"
                      name="Clave SAT del producto"
                      :rules="validationRules.satProductKey"
                    >
                      <b-form-input
                        v-model="product_catalog.sat_product_key"
                        size="lg"
                        class="font-weight-bolder"
                        autocomplete="off"
                        type="text"
                        inputmode="numeric"
                        maxlength="8"
                        placeholder="30111601"
                        @input="sanitizeSatProductKey"
                      />
                      <small class="text-muted">8 dígitos según el catálogo SAT.</small>
                      <small class="text-danger d-block">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col
                  sm="12"
                  lg="4"
                >
                  <b-form-group label="Clave SAT de unidad">
                    <validation-provider
                      #default="{ errors }"
                      name="Clave SAT de unidad"
                      :rules="validationRules.satUnitKey"
                    >
                      <b-form-input
                        v-model="product_catalog.sat_unit_key"
                        size="lg"
                        class="font-weight-bolder text-uppercase"
                        autocomplete="off"
                        type="text"
                        maxlength="4"
                        placeholder="H87"
                        @input="sanitizeSatUnitKey"
                      />
                      <small class="text-muted">Ejemplo: H87, XBX, MTR.</small>
                      <small class="text-danger d-block">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col
                  sm="12"
                  lg="4"
                >
                  <b-form-group label="Nombre SAT de unidad">
                    <b-form-input
                      v-model="product_catalog.sat_unit_name"
                      size="lg"
                      class="font-weight-bolder"
                      autocomplete="off"
                      type="text"
                      maxlength="60"
                      placeholder="Pieza, Bulto, Metro"
                    />
                    <small class="text-muted">Texto que aparecerá en la factura.</small>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="border-secondary p-2 m-0 mt-1 custom-border">
                <!-- <b-col sm="12">
                  <h2>{{ $t('productImage') }}</h2>
                  <b-row class="align-items-center">
                    <b-col
                      v-if="product_catalog.logo"
                      sm="12"
                      lg="3"
                    >
                      <b-img
                        v-if="previewImg"
                        fluid
                        :src="previewImg"
                      />
                      <b-img
                        v-else
                        fluid
                        :src="product_catalog.logo"
                      />
                    </b-col>
                    <b-col
                      sm="12"
                      lg="9"
                    >
                      <span class="text-muted">{{ $t('resolutionInfo') }}</span>
                      <div
                        v-if="productImage"
                        class="mt-1"
                      >
                        <span class="text-primary mr-1">
                          {{ productImage.name }}
                        </span>
                        <span class="text-primary">
                          {{ productImage.size | prettyBytes }}
                        </span>
                      </div>
                      <b-row class="mt-1">
                        <b-col sm="12">
                          <b-form-file
                            v-model="productImage"
                            accept="image/*"
                            placeholder="Choose a file or drop it here..."
                            drop-placeholder="Drop file here..."
                            @input="createImage"
                          />
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col> -->
                <b-col sm="12">
                  <h2>{{ $t('productImage') }}</h2>
                  <div class="d-flex">
                    <base-cropper
                      :model="product_catalog"
                      @cropped-image="product_catalog.logo = $event"
                    />
                    <span class="text-muted ml-1">{{
                      $t('resolutionInfo')
                    }}</span>
                  </div>
                </b-col>
              </b-row>
              <b-row class="justify-content-end mt-2">
                <b-col>
                  <b-button
                    variant="primary"
                    size="lg"
                    class="px-5"
                    type="submit"
                  >
                    {{ $t('save') }}
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>
        </b-card>
      </b-col>
      <b-col
        class="d-flex align-items-center justify-content-center"
        lg="4"
        xl="6"
      >
        <b-img
          :src="require('@/assets/images/pages/forgot-password-v2.svg')"
          width="500px"
          fluid
        />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { required, digits, regex } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'
import BaseCropper from '@/components/BaseCropper.vue'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BaseCropper,
    vSelect,
  },
  data() {
    return {
      product_catalog: {
        name: '',
        category_id: '',
        sku: '',
        description: '',
        logo: null,
        unit_type: 0,
        sat_product_key: '',
        sat_unit_key: '',
        sat_unit_name: '',
        product_tag_ids: [],
      },
      // eslint-disable-next-line
      productImage: null,
      // eslint-disable-next-line
      previewImg: null,
      required,
      digits,
      regex,
      validationRules: {
        satProductKey: 'digits:8',
        satUnitKey: {
          regex: /^[A-Za-z0-9]{2,4}$/,
        },
      },
      unitTypeOptions: [
        {
          value: 'meter',
          text: this.$t('meter'),
        },
        {
          value: 'square_meters',
          text: this.$t('squareMeters'),
        },
        {
          value: 'cubic_meters',
          text: this.$t('cubicMeters'),
        },
        {
          value: 'piece',
          text: this.$t('piece'),
        },
        {
          value: 'kilogram',
          text: this.$t('kilogram'),
        },
        {
          value: 'ton',
          text: this.$t('ton'),
        },
        {
          value: 'bundle',
          text: this.$t('bundle'),
        },
        {
          value: 'box',
          text: this.$t('box'),
        },
        {
          value: 'trip',
          text: this.$t('trip'),
        },
        {
          value: 'pallet',
          text: this.$t('pallet'),
        },
      ],
    }
  },
  computed: {
    ...mapGetters('categories', ['categories']),
    ...mapGetters('productTags', ['productTags']),
  },
  created() {
    this.fetchCategories()
    this.fetchProductTags()
    this.fetchProduct({ productId: this.$route.params.productId }).then(
      response => {
        this.product_catalog = {
          ...response,
          product_tag_ids: (response.product_tags || []).map(tag => tag.id),
        }
      },
    )
  },
  methods: {
    ...mapActions('categories', ['fetchCategories']),
    ...mapActions('productTags', ['fetchProductTags']),
    ...mapActions('products', ['editProduct', 'fetchProduct']),
    sanitizeSatProductKey(value) {
      this.product_catalog.sat_product_key = value.toString().replace(/\D/g, '').slice(0, 8)
    },
    sanitizeSatUnitKey(value) {
      this.product_catalog.sat_unit_key = value.toString().replace(/[^a-zA-Z0-9]/g, '').toUpperCase().slice(0, 4)
    },

    validateForm() {
      this.$refs.formValidation.validate().then(success => {
        if (success) {
          this.editProduct(this.product_catalog).then(() => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t('productCreated'),
                icon: 'EditIcon',
                variant: 'success',
              },
            })
            this.$router.push({ name: 'productsCatalogs' })
          })
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.custom-border {
  border-radius: 4px;
}
</style>
